export default {
    navigationBarTitleText: '编辑模型',
};
